import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EventSearchParametersStore } from '../../event/service/event-search-parameters.store';
import { EventMenuSearchFilter } from '../../event/models/event-menu-search-filter';
import { EventSearchFormsStore } from '../../event/service/event-search-forms.store';

@Component({
  selector: 'pioneer-event-search-filter',
  templateUrl: './event-search-filter.component.html'
})
export class EventSearchFilterComponent implements OnInit {

  public eventFilterForm: FormGroup;
  public isEventFilterMenuExpanded = false;

  constructor(
    private eventSearchParametersStore: EventSearchParametersStore,
    private eventSearchFormsStore: EventSearchFormsStore) {
  }

  ngOnInit() {
    this.eventFilterForm = this.eventSearchFormsStore.filterForm;
    this.isEventFilterMenuExpanded = this.eventSearchFormsStore.isEventFilterOptionSelected();
  }

  returnToSearchList(): void {
    this.eventSearchParametersStore.updateUrl();
  }

  applySearchFilters(model: any): void {
    const filterRecord: EventMenuSearchFilter = this.eventSearchFormsStore.createFilterRecord(model);
    this.eventSearchFormsStore.searchFromFilter(filterRecord);
  }

  resetSearchFilters(): void {
    this.eventSearchParametersStore.resetFilters(true);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/menus/event-search-filter/event-search-filter.component.ts